import type { ArdoqId } from '@ardoq/api-types';
import type { BubbleChartDataPointModel } from '@ardoq/bubble-chart';
import { uniq } from 'lodash';

export const getBubbleChartViewComponentIds = (
  data: BubbleChartDataPointModel[]
): ArdoqId[] => uniq(data.map(({ cid }) => cid));
